import { PopupService } from '@/services/popup.service'

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    listpopup: []
};


const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog')
    },
    closeDialog({ commit }) {
        commit('closedialog')
    },
    list({ commit }) {
        commit('setloading')
        commit('resetList')
        PopupService.list().then(data => {
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    Delete({ dispatch, commit }, delete_id) {
        PopupService.hapus(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
            PopupService.list().then(data => {
                commit('addResponseApp', data);
            }, error => {
                console.log(error);
            });
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    Add({ dispatch, commit }, newData) {
        commit('setloading');
        PopupService.add(newData)
            .then(data => {
                dispatch('alert/success', 'Add data Successfully', { root: true });
                commit('ShowAdd', data);
                PopupService.list().then(data => {
                    commit('addResponseApp', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    Edit({ dispatch, commit }, editdata) {
        PopupService.edit(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}


const mutations = {
    resetList(state){
        state.listpopup = []
    },
    setloading(state) {
        state.loading = true
    },
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
    },
    addResponseApp(state, apps) {
        state.listpopup = []
        state.listpopup = apps.data.content;
        state.loading = false;
        state.dialog = false;
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const Popup = {
    namespaced: true,
    state,
    actions,
    mutations
};
